export const When = ({ condition, children }) => (condition ? children : null);

export const Otherwise = ({ children }) => children;

export const If = ({ condition, children }) => (condition ? children : null);

export const Choose = ({ children }) => {
  const whenChild = children.find(
    (child) => child.type === When && child.props.condition
  );
  const otherwiseChild = children.find((child) => child.type === Otherwise);

  return whenChild || otherwiseChild || null;
};
